<div class="dialog-backdrop">
  <form [formGroup]="resumeForm" class="dialog-box">
    <div class="dialog-header">
      <h3>Save Resume</h3>
    </div>

    <div class="dialog-body">
      <label>Resume Name</label>

      <input
        type="text"
        placeholder="Enter resume name"
        formControlName="resume_name"
      />

      <small class="text-danger smaller-text"
        *ngIf="
          resumeForm.get('resume_name')?.invalid &&
          resumeForm.get('resume_name')?.touched
        "
      >
        Resume name is required
      </small>
    </div>

    <div class="dialog-footer">
      <button type="button" class="btn cancel-btn" (click)="onCancel()">
        Cancel
      </button>

      <button type="button" class="btn save-btn" (click)="onSave()">
        Save
      </button>
    </div>
  </form>
</div>
